/**
 * @file コンポーネント：症例サムネイル画像 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledMediaImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: inherit;
`;
